exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.w-tag[data-v-837e2cc4] {\n  width: 150px;\n}\n/* .tag-view {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr; */\n/* } */\n", ""]);

// exports
